import React from 'react';
import { sanitizeD365RichTextEditor } from 'src/features/one-way-in/utils/htmlTextConverter';
import EmailPreview from './EmailPreview';

type Props = {
  note: string;
  receivingActor: string;
  opportunityTitle: string;
  fromActorName: string;
  handlerName?: string;
};

const ReferralMailActor: React.FC<Props> = ({
  note,
  receivingActor,
  opportunityTitle,
  fromActorName,
  handlerName,
}) => {
  const noteIsHtml = /<\/?[a-z][\s\S]*>/i.test(note);

  if (noteIsHtml) {
    return (
      <EmailPreview>
        <div dangerouslySetInnerHTML={{ __html: sanitizeD365RichTextEditor(note) }} />
        <span>MERK: Svar til denne e-postadressen blir ikke behandlet.</span>
      </EmailPreview>
    );
  }

  return (
    <EmailPreview>
      <p>
        Aktør <b>{receivingActor}</b>, har mottatt ny henvisning fra aktør <b>{fromActorName}</b>. Tittel på
        henvendelsen: <em>{opportunityTitle}</em>. Gå til <b>flerbedriftsportal.no</b> for å følge opp
        kunden/henvendelsen.
      </p>
      <p>Melding fra {fromActorName}:</p>
      <p className="white-space--pre-wrap">{note}</p>
      {handlerName && <p>Med vennlig hilsen {handlerName}</p>}
      <p>MERK: Svar til denne e-postadressen blir ikke behandlet.</p>
    </EmailPreview>
  );
};

export default ReferralMailActor;
